import { z } from 'zod';
export const GameId = z.enum(['candy', 'sakura']);
export const GameStatus = z.enum(['playable', 'coming_soon', 'maintenance']);
export const GameBadge = z.enum(['HOT', 'NEW', 'JACKPOT']);
export const GameMeta = z.object({
    id: GameId,
    brand_name: z.string(),
    status: GameStatus,
    asset_dir: z.string(),
    banner_url: z.string().nullable(),
    badge: GameBadge.nullable(),
});
export const GAME_REGISTRY = {
    candy: {
        id: 'candy',
        brand_name: 'Neon Candy Fortune',
        status: 'playable',
        asset_dir: 'neon-candy-fortune',
        banner_url: null,
        badge: 'HOT',
    },
    sakura: {
        id: 'sakura',
        brand_name: 'Sakura Neon Fortune',
        status: 'playable',
        asset_dir: 'sakura-neon-fortune',
        banner_url: null,
        badge: 'NEW',
    },
};
/** Lobby 只展示 playable + coming_soon；maintenance 不进 ALL_GAMES */
export const ALL_GAMES = Object.values(GAME_REGISTRY).filter((g) => g.status !== 'maintenance');
//# sourceMappingURL=games.js.map